import { render, staticRenderFns } from "./AccountHolderInvestment.vue?vue&type=template&id=4faa549c&scoped=true"
import script from "./AccountHolderInvestment.vue?vue&type=script&lang=ts"
export * from "./AccountHolderInvestment.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderInvestment.vue?vue&type=style&index=0&id=4faa549c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faa549c",
  null
  
)

export default component.exports